import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import logo from "../Dashboard/assets/img/logo.png";
import LoginSignupMessage from "./siteComponents/LoginSignupMessage";
import { BASE_URL, HOST_URL } from "../Dashboard/api/Api";
import GoogleLinkedinLogin from "./GoogleLinkedinLogin";
import { ref } from "yup";
import Axios from "../../axios/Axios";
import { handleUserLog } from "../Utils/Utils";

class Login extends Component {
  constructor() {
    super();
    this.state = {
      username: "",
      password: "",
      isfacebooklogin: false,
      show: false,
      loginMessage: "",
      bgColor: "",
      url: false,
      tfa: false,
      redirectAfterLogin: null,
      login_by_Value: "",
      otp: "",
      pin: "",
      source: "",
      ip: "0.0.0.0"
    };
    this.keyPressed = this.keyPressed.bind(this);
    this.login = this.login.bind(this);
  }



  keyPressed(event) {
    if (event.key === "Enter") {
      this.login();
    }
  }

  componentDidMount() {
    this.getUserIP();
  }

  getUserIP = () => {
    fetch("https://api.ipify.org?format=json")
      .then((res) => res.json())
      .then((data) => {
        this.setState({ ip: data?.ip ? data.ip : "0.0.0.0" });
      })
      .catch((err) => {
        console.error("Error fetching IP:", err);
        this.setState({ ip: "0.0.0.0" });
      });
  };

  submitOtp = () => {
    const loginData = {
      username: this.state.username,
      password: this.state.password,
      otp: this.state.otp,
      login_by: this.state.login_by_Value,
    };

    Axios.post(`${HOST_URL}/login1.php`, loginData, {
      headers: { 'Content-Type': 'application/json' }
    })
      .then(res => {
        const resp = res.data;
        if (resp.success === true) {
          this.setState({
            show: true,
            loginMessage: "Success",
            bgColor: "alert alert-success",
            response: resp,
            error: null,
          });

          const url = window.location.host;

          if (resp.user.userId === 8407) {
            localStorage.setItem("stanmaxuser", JSON.stringify(resp));
            setTimeout(() => window.location = "/stanmax/whatsappconv", 1000);
            return;
          }

          if (resp.user.isAdmin === "client") {
            resp["url"] = url;
            localStorage.setItem("login", JSON.stringify(resp));
            localStorage.setItem("admin", JSON.stringify({ success: false }));
            const redirectTo = this.state.redirectAfterLogin || "/dashboard";
            setTimeout(() => {
              if (redirectTo === "/dashboard/whatsapp-onboarding-new") {
                window.open(redirectTo, "_blank");
              } else {
                window.location.href = redirectTo;
              }
            }, 1000);
          } else if (resp.user.isAdmin === "admin") {
            localStorage.setItem("admin", JSON.stringify(resp));
            setTimeout(() => window.location = "/admin", 1000);
          } else if (resp.user.isAdmin === "emp") {
            localStorage.setItem("emp", JSON.stringify(resp));
            setTimeout(() => window.location = "/admin", 1000);
          } else if (resp.user.isAdmin === "reseller") {
            localStorage.setItem("reseller", JSON.stringify(resp));
            setTimeout(() => window.location = "/admin", 1000);
          }
        } else {
          this.setState({
            show: true,
            loginMessage: resp.message,
            bgColor: "alert alert-danger",
          });
        }
      })
      .catch(err => {
        const errorMsg = err.response ? err.response.data : 'Network error';
        this.setState({ error: errorMsg, response: null });
      });
  };



  submitPin = () => {
    const loginData = {
      username: this.state.username,
      password: this.state.password,
      pin: this.state.pin,
      login_by: this.state.login_by_Value,
    };

    Axios.post(`${HOST_URL}/login1.php`, loginData, {
      headers: { 'Content-Type': 'application/json' }
    })
      .then(res => {
        const resp = res.data;
        if (resp.success === true) {
          this.setState({
            show: true,
            loginMessage: "Success",
            bgColor: "alert alert-success",
            response: resp,
            error: null,
          });

          const url = window.location.host;

          if (resp.user.userId === 8407) {
            localStorage.setItem("stanmaxuser", JSON.stringify(resp));
            setTimeout(() => window.location = "/stanmax/whatsappconv", 1000);
            return;
          }

          if (resp.user.isAdmin === "client") {
            resp["url"] = url;
            localStorage.setItem("login", JSON.stringify(resp));
            localStorage.setItem("admin", JSON.stringify({ success: false }));
            const redirectTo = this.state.redirectAfterLogin || "/dashboard";
            setTimeout(() => {
              if (redirectTo === "/dashboard/whatsapp-onboarding-new") {
                window.open(redirectTo, "_blank");
              } else {
                window.location.href = redirectTo;
              }
            }, 1000);
          } else if (resp.user.isAdmin === "admin") {
            localStorage.setItem("admin", JSON.stringify(resp));
            setTimeout(() => window.location = "/admin", 1000);
          } else if (resp.user.isAdmin === "emp") {
            localStorage.setItem("emp", JSON.stringify(resp));
            setTimeout(() => window.location = "/admin", 1000);
          } else if (resp.user.isAdmin === "reseller") {
            localStorage.setItem("reseller", JSON.stringify(resp));
            setTimeout(() => window.location = "/admin", 1000);
          }
        } else {
          this.setState({
            show: true,
            loginMessage: resp.message,
            bgColor: "alert alert-danger",
          });
        }
      })
      .catch(err => {
        const errorMsg = err.response ? err.response.data : 'Network error';
        this.setState({ error: errorMsg, response: null });
      });
  };



  componentDidMount() {
    localStorage.clear();
    const hostUrl = window.location.host;
    const params = new URLSearchParams(window.location.search);

    const source = params.get("source");

    this.setState({
      source: source || "",
    });

    // const ref = params.get("ref");

    // if (ref) {
    //   this.setState({ redirectAfterLogin: ref });
    // }

    // Capture where the user came from (Protected redirect)
    const fromState = this.props.location?.state?.from;
    if (fromState) {
      this.setState({ redirectAfterLogin: fromState.pathname });
    } else if (params.get("ref")) {
      this.setState({ redirectAfterLogin: params.get("ref") });
    }

    if (hostUrl !== BASE_URL || "localhost:3001") {
      this.setState({ url: true });
    } else {
      this.setState({ url: false });
    }
    var url = document.location.href;
    var mainURL = "console.authkey.io";
    var localHost = "localhost:3001";
    if (url.indexOf(localHost) !== -1 || url.indexOf(mainURL) !== -1) {
      // console.log("URL test passed");
    } else {
      window.location = "/my-account";
    }
  }




  login() {
    this.setState({ loginMessage: false });
    var url = window.location.host;
    fetch(`${HOST_URL}/login1.php`, {
      method: "post",
      headers: {
        "content-Type": "application/json",
      },
      body: JSON.stringify(this.state),
    }).then((result) => {
      result.json().then((resp) => {
        // console.log('Full API Response:', resp);
        // console.log('login_by:', resp.login_by);

        if (resp.success === true) {
          this.setState({ login_by_Value: resp.login_by });

          if (resp.login_by === 0) {
            this.setState({
              show: true,
              loginMessage: "Success",
              bgColor: "alert alert-success",
            });

            handleUserLog(this.state.username, "login", "login", resp.message || "Login Successfully", "login", this.state.ip ,"");

            if (resp.user.userId === 8407) {
              localStorage.setItem("stanmaxuser", JSON.stringify(resp));

              setTimeout(function () {
                window.location = "/stanmax/whatsappconv";
              }, 1000);
              return;
            }
            if (resp.user.isAdmin === "client") {
              resp["url"] = url;
              resp["ip"] = this.state.ip;
              localStorage.setItem("login", JSON.stringify(resp));
              localStorage.setItem("admin", JSON.stringify({ success: false }));
              const redirectTo = this.state.redirectAfterLogin
                ? this.state.redirectAfterLogin
                : "/dashboard";
              // setTimeout(function () {

              //   window.open(redirectTo, "_blank");
              // }, 1000);
              setTimeout(() => {
                if (redirectTo === "/dashboard/whatsapp-onboarding-new") {
                  window.open(redirectTo, "_blank");
                } else {
                  window.location.href = redirectTo; // Same tab redirect
                }
              }, 1000);
            } else if (resp.user.isAdmin === "admin") {
              localStorage.setItem("admin", JSON.stringify(resp));
              setTimeout(function () {
                window.location = "/admin";
              }, 1000);
            } else if (resp.user.isAdmin === "emp") {
              localStorage.setItem("emp", JSON.stringify(resp));
              setTimeout(function () {
                window.location = "/admin";
              }, 1000);
            } else if (resp.user.isAdmin === "reseller") {
              localStorage.setItem("reseller", JSON.stringify(resp));
              setTimeout(function () {
                window.location = "/admin";
              }, 1000);
            }
          }
          else if (resp.login_by === 1) {
            this.setState({
              show: true,
              loginMessage: "OTP required. Please enter the OTP sent to your device.",
              bgColor: "alert alert-info",
            });
          }
          else if (resp.login_by === 2) {
            this.setState({
              show: true,
              loginMessage: "PIN required. Please enter your PIN.",
              bgColor: "alert alert-info",
            });
          }
        }
        else {
          handleUserLog(this.state.username, "login", "login", resp.message, "login", this.state.ip, "");
          this.setState({
            show: true,
            loginMessage: resp.message,
            bgColor: "alert alert-danger",
          });
        }
      });
    });
  }

  responseFacebook = (response) => {
    const loginWithFacebook = {
      email: response.email,
      name: response.name,
      api_response: response,
    };
    var url = document.location.href;
    fetch(`${HOST_URL}/facebook_login.php`, {
      method: "post",
      headers: {
        "content-Type": "application/json",
      },
      body: JSON.stringify(loginWithFacebook),
    }).then((result) => {
      result.json().then((resp) => {
        if (resp.success === true && resp.account === "old") {
          this.setState({
            show: true,
            bgColor: "alert alert-success alert-dismissible",
            loginMessage: "success",
          });
          resp["url"] = url;
          localStorage.setItem("login", JSON.stringify(resp));
          localStorage.setItem("admin", JSON.stringify({ success: false }));
          setTimeout(function () {
            window.location = "/dashboard";
          });
        } else if (resp.success === true && resp.account === "new") {
          resp["url"] = url;
          this.setState({
            show: true,
            bgColor: "alert alert-success alert-dismissible",
            loginMessage: "success",
          });
          localStorage.setItem("login", JSON.stringify(resp));
          localStorage.setItem("admin", JSON.stringify({ success: false }));
          setTimeout(function () {
            window.location = "/signup-success";
          });
        } else {
          this.setState({
            show: true,
            bgColor: "alert alert-danger alert-dismissible",
            loginMessage: resp.message,
          });
        }
      });
    });
  };


  render() {
    // console.log("Render called. showOtpBox is:", this.state.showOtpBox);

    document.querySelector("body").scrollTo(0, 0);
    return (
      <div>
        <div>
          {" "}
          <Helmet>
            <title>
              Login | Authkey
            </title>
            <meta
              name="description"
              content="Access your Authkey dashboard by logging in securely. Manage your API keys, messaging services, and account settings with ease."
            />
            <link rel="canonical" href="https://console.authkey.io/login" />
            <style type="text/css">{`
                        .deals-and-offers {
                            display:none !important;
                        }
                        @media only screen and (max-width: 600px) {
                            .mobile-img {
                            display: none;
                            }
                        }
                    `}</style>
          </Helmet>

          <section style={{ background: "#fff" }} className="loginbg">
            <div className=" container-fluid d-flex flex-column">
              <div className="row justify-content-center heightVh min-vh-100">
                <LoginSignupMessage />
                <div className="col-lg-6 col-xl-6 py-md-0">
                  <div className="login-new-box heightVh">
                    {this.state.tfa === false ? (
                      <form className="form-row col-sm-10 pt-2 col-md-6 col-lg-10 pl-md-5 pr-sm-0">
                        {this.state.show ? (
                          <div className="form-group col-md-12">
                            <div className={this.state.bgColor}>
                              {this.state.loginMessage}
                            </div>
                          </div>
                        ) : null}

                        <div className="mb-0 col-md-12 text-left login-box">
                          <Link to="/">
                            <img
                              className="img-fluid mb-3"
                              src={logo}
                              style={{ width: "50%" }}
                              alt=""
                            />
                          </Link>

                        </div>
                        <div className="form-group mt-3 position-relative col-md-12 mb-2">

                          {/* <p className="m-auto mb-6 login-with right-50 d-block  position-absolute ">
                            Sign in with
                          </p> */}
                        </div>
                        {/* <button className="col-lg-12 flex items-center px-6 py-2 border rounded-lg shadow-md hover:shadow-lg focus:outline-none">
                          <img
                            src="https://www.svgrepo.com/show/303108/google-icon-logo.svg" style={{ width: "20px", height: "20px" }}
                            alt="Google Logo"
                            className="w-6 h-6 mr-3"
                          />
                          <span className="text-gray-700 font-medium">Continue with Google</span>
                        </button> */}




                        {/* <div className="m-auto">
                          <FacebookLogin
                            className="facebook"
                            appId="4884679621657801"
                            textButton="Login With Facebook"
                            autoLoad={false}
                            fields="name,email"
                            callback={this.responseFacebook}
                          />
                        </div> */}
                        <div className="col-md-12 d-flex justify-content-center mb-2">
                          <div
                            className="d-flex align-items-center justify-content-center"
                            style={{ width: "100%", maxWidth: "300px" }}
                          >
                            <GoogleLinkedinLogin redirectPath={this.state.redirectAfterLogin} context="login" />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="d-flex align-items-center my-1">
                            <hr className="flex-grow-1 border-secondary" />
                            <span className="mx-3 text-muted fw-semibold">OR</span>
                            <hr className="flex-grow-1 border-secondary" />
                          </div>
                        </div>
                        <div className="form-group col-md-12 mt-2">

                          <h3 className="">Login </h3>
                          <label className="form-control-label">
                            Email address
                          </label>
                          <div className="input-group">
                            <input
                              type="text"
                              required
                              name="username"
                              onChange={(event) =>
                                this.setState({ username: event.target.value })
                              }
                              className="form-control logininput"
                              placeholder="name@example.com"
                            />
                          </div>
                        </div>
                        <div className="form-group col-md-12 mb-0">
                          <label className="form-control-label">
                            Enter Password
                          </label>
                          <div className="input-group ">
                            <input
                              type="password"
                              onKeyPress={this.keyPressed}
                              autoComplete="no"
                              required
                              name="password"
                              onChange={(event) =>
                                this.setState({ password: event.target.value })
                              }
                              className="form-control logininput"
                              placeholder="Password"
                            />
                          </div>

                          <div >
                            {this.state.login_by_Value === 1 && (
                              <div className="otp-box ">
                                <div>
                                  <label className="form-label">Enter OTP:</label>
                                  <input
                                    type="text"
                                    maxLength="6"
                                    className="form-control mb-2"
                                    value={this.state.otp}
                                    onChange={(e) => this.setState({ otp: e.target.value })}
                                  />
                                </div>
                                <button
                                  type="button"
                                  className="btn"
                                  style={{ backgroundColor: "#3a3462", color: "#fff", }}
                                  onClick={this.submitOtp}
                                >
                                  Submit OTP
                                </button>
                              </div>
                            )}

                            {this.state.login_by_Value === 2 && (
                              <div className="pin-box">
                                <div>
                                  <label className="form-label">Enter PIN:</label>
                                  <input
                                    type="password"
                                    className="form-control mb-2"
                                    value={this.state.pin}
                                    onChange={(e) => this.setState({ pin: e.target.value })}
                                  />
                                </div>
                                <button
                                  type="button"
                                  className="btn"
                                  style={{ backgroundColor: "#3a3462", color: "#fff", }}
                                  onClick={this.submitPin}
                                >
                                  Submit PIN
                                </button>
                              </div>
                            )}
                          </div>
                          <div className="row">
                            <div className="mt-4 col-md-12 text-left">
                              <div className="d-flex justify-content-between">
                                <p className="small">
                                  <Link to={`/signup?source=${encodeURIComponent(this.state.source)}`}>
                                    Don't have an Account ?
                                  </Link>
                                </p>
                                <p className="Forgot">
                                  <Link to="forgot-password">
                                    Forgot Password ?
                                  </Link>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mt-2 d-flex w-100 justify-content-between">
                          <button
                            type="button"
                            onClick={() => {
                              this.login();
                            }}
                            className="home-button mx-0 btn-signup"
                            style={{ width: "48%" }}
                          >
                            Log in
                          </button>

                          <Link to={`/signup?source=${encodeURIComponent(this.state.source)}`} style={{ width: "48%" }}>
                            <button
                              type="button"
                              style={{ background: "#fff" }}
                              className=" home-button mx-0 w-100"
                            >
                              Create Account
                            </button>
                          </Link>
                        </div>

                        {/* <div className="form-group mt-5 position-relative col-md-12 mb-4">
                          <hr className="mt-0 mb-0" />
                          <p className="m-auto login-with right-50 d-block  position-absolute ">
                            Sign in with
                          </p>
                        </div>
                        <div className="m-auto">
                          <FacebookLogin
                            className="facebook"
                            appId="4884679621657801"
                            textButton="Login With Facebook"
                            autoLoad={false}
                            fields="name,email"
                            callback={this.responseFacebook}
                          />
                        </div> */}

                        <div
                          style={{
                            textAlign: "center",
                            width: "100%",
                            marginTop: "20px",
                          }}
                        >
                          <small style={{ fontSize: "9px" }}>
                            {`© 2020-${new Date().getFullYear()} AuthKey.io is a product of Datagen Internet Services Pvt. Ltd. | All rights reserved`}
                          </small>
                        </div>
                      </form>
                    ) : (
                      <>

                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </section>{" "}
        </div>
      </div>
    );
  }
}
export default Login;
